import { MobileGarantieLogo } from "@App/Components/atoms/whitelabel/logos/MobileGarantieLogo";
import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import type { Config } from "@App/configs/interfaces";

/**
 * Configuration for the mobile GARANTIE whitelabel.
 * Extends the default configuration with specific settings for mobile GARANTIE.
 */
export const config: Partial<Config> = {
  slug: "mobile-garantie",
  navbar: {
    logos: {
      left: {
        component: <MobileGarantieLogo />,
      },
      right: {
        component: <RepareoLogo />,
      },
    },
    backToPartnerButton: {
      url: "https://www.mobile-garantie.de/",
    },
  },
  reviews: {
    show: true,
  },
  checkout: {
    vin: {
      display: false,
      required: false,
    },
    claimNumber: {
      display: () => false,
      required: () => false,
    },
    contractNumber: {
      display: true,
    },
    optIns: {
      reviewOptIn: {
        show: false,
      },
    },
  },
};

export default config;
